import React from 'react';
import { AdminLayout } from 'apps/sigma2-ui/src/components/AdminLayout';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { SimpleInput } from 'apps/sigma2-ui/src/components/ui/SimpleInput';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { SaveIndicator } from 'apps/sigma2-ui/src/components/SaveIndicator';
import { useDataSetEditPage } from 'apps/sigma2-ui/src/data-wizard/lib/useDataSetEditPage';
import { DataSetConfigurationComponent } from 'apps/sigma2-ui/src/data-wizard/components/DataSetConfigurationComponent';
import { AdminBreadcrumbs } from 'apps/sigma2-ui/src/components/ui/AdminBreadcrumbs';
import { S2Checkbox } from 'apps/sigma2-ui/src/components/ui/Checkbox';

export const DataSetEditPage = () => {
  const {
    databaseId,
    databaseName,
    displayNameLabel,
    displayName,
    isArchived,
    setIsArchived,
    setDisplayName,
    typeLabel,
    integrationTypeLabel,
    supplementalDataSetTypeLabel,
    submitButtonBehavior,
    submitButtonLabel,
    submitButtonDisabled,
    backButtonBehavior,
    backButtonLabel,
    backButtonDisabled,
    copyButtonLabel,
    copyButtonBehavior,
    copyButtonDisabled,
    saveIndicatorStatus,
    dataSetType,
    fileName,
    fileNameLabel,
    setFileName,
    organizationId,
    integrationType,
    supplementalDataSetType,
    clientIdSecretReference,
    clientSecretSecretReference,
    usernameSecretReference,
    passwordSecretReference,
    folderIdSecretReference,
    fileNameSecretReference,
    setClientIdSecretReference,
    setClientSecretSecretReference,
    setUsernameSecretReference,
    setPasswordSecretReference,
    setFolderIdSecretReference,
    setFileNameSecretReference,
    apiKeySecretReference,
    setApiKeySecretReference,
    listSecretsPattern,
    candidatesUrlSecretReference,
    compensationChangeHistoryUrlSecretReference,
    employeeHistoryUrlSecretReference,
    setCandidatesUrlSecretReference,
    setCompensationChangeHistoryUrlSecretReference,
    setEmployeeHistoryUrlSecretReference,
    setStaffingEventsUrlSecretReference,
    staffingEventsUrlSecretReference,
    setOauthUrlSecretReference,
    oauthUrlSecretReference,
    setApiBaseUrlSecretReference,
    apiBaseUrlSecretReference,
    isLoading,
    httpIntegrationHook,
    postgresIntegrationHook,
    mergeIntegrationHook,
    tryCreateMergeMagicLink,
    integrationFieldValidationErrors,
    externalMergeLink,
    compositeHook,
    supplementalHook,
    sslCertSecretReference,
    keyCertSecretReference,
    setKeyCertSecretReference,
    setSslCertSecretReference,
    dataSetId,
    dbtAction,
    setDbtAction,
    agentMode,
    setAgentMode,
    agentDateCap,
    setAgentDateCap,
    sqlServerIntegrationHook,
  } = useDataSetEditPage();

  return (
    <AdminLayout currentPage={'DataSetEdit'}>
      <AdminBreadcrumbs
        items={[
          { label: 'Home', to: '/admin' },
          { label: 'Organizations', to: '/organizations' },
          {
            label: 'Databases',
            to: `/organizations/${organizationId}/databases`,
          },
          {
            label: 'Edit Database',
            to: `/organizations/${organizationId}/databases/edit/${databaseId}`,
          },
          {
            label: 'Data Sets',
            to: `/organizations/${organizationId}/databases/${databaseId}/data-sets`,
          },
          {
            label: 'Edit Data Set',
            to: `/organizations/${organizationId}/databases/${databaseId}/data-sets/edit/${dataSetId}`,
          },
        ]}
      />
      {!isLoading && (
        <Spacing size={'md'} direction={'vertical'}>
          <Paragraph>Tell us more about your data set.</Paragraph>
          <Paragraph>Database: {databaseName}</Paragraph>

          <div>
            <SimpleInput
              label={displayNameLabel}
              value={displayName}
              onChange={setDisplayName}
            />
          </div>

          <S2Checkbox
            checked={isArchived}
            onChange={() => {
              setIsArchived(!isArchived);
            }}
          >
            {'Is Archived'}
          </S2Checkbox>

          <Paragraph>
            {typeLabel}: {dataSetType}
          </Paragraph>

          {dataSetType === 'Integration' && (
            <Paragraph>
              {integrationTypeLabel}: {integrationType}
            </Paragraph>
          )}

          {dataSetType === 'Supplemental' && (
            <Paragraph>
              {supplementalDataSetTypeLabel}: {supplementalDataSetType}
            </Paragraph>
          )}

          {externalMergeLink && (
            <Button
              behavior={{
                type: 'onClick',
                onClick: () => {
                  window.open(externalMergeLink, '_blank', 'noreferrer');
                },
              }}
              text={'Go to Merge'}
            />
          )}

          <DataSetConfigurationComponent
            dataSetType={dataSetType}
            fileName={fileName}
            fileNameLabel={fileNameLabel}
            setFileName={setFileName}
            organizationId={organizationId}
            integrationType={integrationType}
            clientIdSecretReference={clientIdSecretReference}
            clientSecretSecretReference={clientSecretSecretReference}
            usernameSecretReference={usernameSecretReference}
            passwordSecretReference={passwordSecretReference}
            folderIdSecretReference={folderIdSecretReference}
            fileNameSecretReference={fileNameSecretReference}
            setClientIdSecretReference={setClientIdSecretReference}
            setClientSecretSecretReference={setClientSecretSecretReference}
            setUsernameSecretReference={setUsernameSecretReference}
            setPasswordSecretReference={setPasswordSecretReference}
            setFolderIdSecretReference={setFolderIdSecretReference}
            setFileNameSecretReference={setFileNameSecretReference}
            apiKeySecretReference={apiKeySecretReference}
            setApiKeySecretReference={setApiKeySecretReference}
            listSecretsPattern={listSecretsPattern}
            candidatesUrlSecretReference={candidatesUrlSecretReference}
            compensationChangeHistoryUrlSecretReference={
              compensationChangeHistoryUrlSecretReference
            }
            employeeHistoryUrlSecretReference={
              employeeHistoryUrlSecretReference
            }
            setCandidatesUrlSecretReference={setCandidatesUrlSecretReference}
            setCompensationChangeHistoryUrlSecretReference={
              setCompensationChangeHistoryUrlSecretReference
            }
            setEmployeeHistoryUrlSecretReference={
              setEmployeeHistoryUrlSecretReference
            }
            setStaffingEventsUrlSecretReference={
              setStaffingEventsUrlSecretReference
            }
            staffingEventsUrlSecretReference={staffingEventsUrlSecretReference}
            setOauthUrlSecretReference={setOauthUrlSecretReference}
            oauthUrlSecretReference={oauthUrlSecretReference}
            apiBaseUrlSecretReference={apiBaseUrlSecretReference}
            setApiBaseUrlSecretReference={setApiBaseUrlSecretReference}
            httpIntegrationHook={httpIntegrationHook}
            postgresIntegrationHook={postgresIntegrationHook}
            sqlServerIntegrationHook={sqlServerIntegrationHook}
            mergeIntegrationHook={mergeIntegrationHook}
            compositeHook={compositeHook}
            tryCreateMergeMagicLink={tryCreateMergeMagicLink}
            integrationFieldValidationErrors={integrationFieldValidationErrors}
            sslCertSecretReference={sslCertSecretReference}
            keyCertSecretReference={keyCertSecretReference}
            setKeyCertSecretReference={setKeyCertSecretReference}
            setSslCertSecretReference={setSslCertSecretReference}
            dbtAction={dbtAction}
            setDbtAction={setDbtAction}
            supplementalHook={supplementalHook}
            agentMode={agentMode}
            setAgentMode={setAgentMode}
            agentDateCap={agentDateCap}
            setAgentDateCap={setAgentDateCap}
          />

          <Spacing size="sm" direction="horizontal">
            <Button
              behavior={backButtonBehavior}
              text={backButtonLabel}
              disabled={backButtonDisabled}
            />
            <Button
              behavior={submitButtonBehavior}
              text={submitButtonLabel}
              disabled={submitButtonDisabled}
            />
            <Button
              behavior={copyButtonBehavior}
              text={copyButtonLabel}
              disabled={copyButtonDisabled}
            />
          </Spacing>

          <SaveIndicator status={saveIndicatorStatus} />
        </Spacing>
      )}
    </AdminLayout>
  );
};
